import { render, staticRenderFns } from "./FrequentAddressesOverview.vue?vue&type=template&id=62c1501e&scoped=true&"
import script from "./FrequentAddressesOverview.vue?vue&type=script&lang=js&"
export * from "./FrequentAddressesOverview.vue?vue&type=script&lang=js&"
import style0 from "./FrequentAddressesOverview.vue?vue&type=style&index=0&id=62c1501e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1501e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c1501e')) {
      api.createRecord('62c1501e', component.options)
    } else {
      api.reload('62c1501e', component.options)
    }
    module.hot.accept("./FrequentAddressesOverview.vue?vue&type=template&id=62c1501e&scoped=true&", function () {
      api.rerender('62c1501e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FrequentAddresses/FrequentAddressesOverview.vue"
export default component.exports